// extracted by mini-css-extract-plugin
export default {"wrap":"CancellationReason_wrap__1iMLb","colorBox":"CancellationReason_colorBox__Z-Wvr","button":"CancellationReason_button__2CKmG"};